import React from "react";

import { DeviceFrameset } from "./device-frameset";
import { Container, StyledIframe } from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement> & {
  sourceUrl?: string;
};

export const NewsletterPreview: React.FunctionComponent<Props> = ({ sourceUrl, ...props }) => (
  <Container {...props}>
    <DeviceFrameset>
      <StyledIframe src={sourceUrl ?? ""} />
    </DeviceFrameset>
  </Container>
);

NewsletterPreview.displayName = "NewsletterPreview";
